import React, { useEffect, useState, useRef } from "react";
// import _ from "lodash";
import { connect } from "react-redux";
import { saveChoice, fetchUser, updateMe, endMyExam, signout } from "../actions/index";
import SubmitModal from "../components/modals/SubmitModal";
import PreSubmitModal from "../components/modals/PreLogout";
import NetworkConnectionModal from "../components/modals/NetworkConnectionModal";
import Topbar from "../components/Topbar";

import io from "socket.io-client";
import EarlySubmissionModal from "../components/modals/EarlySubmissionModal";

const socket = io();
let select = 0;

const getStoredSubject = () => {
  try {
    return JSON.parse(localStorage.getItem("currentSubject")) || {};
  } catch (err) {
    return {};
  }
};

// window.onbeforeunload = function (event) {
//     var message = 'Important: Please click on \'Save\' button to leave this page.';
//     if (typeof event == 'undefined') {
//         event = window.event;
//     }
//     if (event) {
//         event.returnValue = message;
//     }
//     return message;
// };

const QuestionPage = (props) => {
  const storedSubject = getStoredSubject();
  const activeSubject = props.candidate?.currentSubject?.integerCode ? props.candidate.currentSubject : storedSubject;
  const activeSubjectCode = activeSubject?.integerCode;
  const activeSubjectQuestions = props.candidate?.questions?.[activeSubjectCode];
  const initialQuestions = activeSubjectQuestions?.questions?.[0]?.groups || [];
  const [candidate, setCandidate] = useState(props.candidate);
  const [questions, setQuestions] = useState(initialQuestions);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(
    candidate.questions?.[storedSubject.integerCode]?.currentQuestionIndex
      ? candidate.questions[storedSubject.integerCode].currentQuestionIndex
      : 0
  );
  const [selectedOption, setSelectedOption] = useState(questions[currentQuestionIndex]?.choice);
  const [isEnd, setIsEnd] = useState(false);
  const [isEarlySubmit, setIsEarlySubmit] = useState(false);
  const [isOpenNModal, setIsOpenNModal] = useState(false);
  const [openPresubmit, setOpenPresubmit] = useState(false);

  const nextButton = useRef();
  const prevButton = useRef();
  const endExamButton = useRef();
  let timerRem = useRef();

  useEffect(() => {
    localStorage.setItem("shouldCount", true);
    localStorage.setItem("totalAttempted", props.candidate.totalAttempted);
    if (!localStorage.getItem("request")) localStorage.setItem("request", JSON.stringify({}));

    socket.on("connect", () => {
      localStorage.setItem("shouldCount", true);
      localStorage.setItem("totalAttempted", props.candidate.totalAttempted);

      setIsOpenNModal(false);
      socket.emit("isStarted", { reg: props.candidate?.registrationNumber, id: props.candidate?.id });
    });

    socket.on("suspendExamCommand", () => {
      setIsEarlySubmit(false);
      sendAnyResponse();
      setTimeout(() => {
        props.signout();
      }, 1000); //call props.suspendExam action here instead
    });

    // socket.on(`relogin-${props.candidate.registrationNumber}`, () => {
    //     sendAnyResponse();
    //     setTimeout(props.signout() , 1000);
    // });
    socket.on("relogin", (data) => {
      if (data.registrationNumber === candidate.registrationNumber) {
        setIsEarlySubmit(false);
        sendAnyResponse();
        setTimeout(() => {
          props.signout();
        }, 1000);
      }
    });

    socket.on("relogin-all", () => {
      setIsEarlySubmit(false);
      sendAnyResponse();
      setTimeout(() => {
        props.signout();
      }, 1000);
    });

    socket.on("releaseIP", (data) => {
      if (data.registrationNumber === candidate.registrationNumber) {
        setIsEarlySubmit(false);
        sendAnyResponse();
        setTimeout(() => {
          props.signout();
        }, 1000);
      }
    });
    socket.on("releaseip-all", () => {
      setIsEarlySubmit(false);
      sendAnyResponse();
      setTimeout(() => {
        props.signout();
      }, 1000);
    });

    socket.on("endcandidatesexam", () => {
      // sendAnyResponse();
      setIsEarlySubmit(false);
      const responses = JSON.parse(localStorage.getItem("request"));
      const timeSpent = Number(localStorage.getItem("timeSpent"));
      if (Object.keys(responses).length > 0) {
        // call SaveChoice actions
        props.saveChoice(props.candidate.id, { responses, timeSpent });
        // Reset request object to empty
        localStorage.setItem("request", JSON.stringify({}));
      }
      // else{
      //     socket.emit('timeSpent', {
      //         candidate: props.candidate.id,
      //         timeSpent
      //     });
      // }
      setOpenPresubmit(true);
      setTimeout(() => {
        setOpenPresubmit(false);
        props.endMyExam(props.candidate.id, timeSpent);
        // localStorage.clear(); check if this prevents browser crash
      }, 6000);
    });

    socket.on("disconnect", () => {
      localStorage.setItem("shouldCount", false);
      setIsOpenNModal(true);
    });

    const checkTimeIntervalId = setInterval(() => {
      if (localStorage.getItem("shouldCount") === "false") return;

      // const timeSpent = (props.candidate.durationInMinutes * 60) - Number(localStorage.getItem('timeLeft'));
      // localStorage.setItem('timeSpent', timeSpent);
      localStorage.setItem("timeSpent", props.candidate.durationInMinutes * 60 - Number(localStorage.getItem("timeLeft")));
      // socket.emit('timeSpent', {id: props.candidate?.id,  timeSpent })
    }, 5000);

    let saveIntervalId = setInterval(() => {
      const responses = JSON.parse(localStorage.getItem("request"));
      // Reduce threshold from 5 to 1 and add timeout-based sending
      if (responses && Object.keys(responses).length >= 1) {
        // call SaveChoice actions
        const timeSpent = Number(localStorage.getItem("timeSpent"));
        props.saveChoice(props.candidate.id, { responses, timeSpent });
        // Reset request object to empty
        localStorage.setItem("request", JSON.stringify({}));
      }
    }, 2000); // Increased interval to 2 seconds to reduce server load

    return () => {
      clearInterval(timerRem);
      clearInterval(saveIntervalId);
      clearInterval(checkTimeIntervalId);
    };
  }, [socket]);

  useEffect(() => {
    const nextQuestions = props.candidate?.questions?.[props.candidate?.currentSubject?.integerCode]?.questions?.[0]?.groups || [];
    setQuestions(nextQuestions);
    // @TODO: also set a state to monitor when to show End Exam button
  }, [props.candidate?.questions]);

  useEffect(() => {
    if (selectedOption === "") return;
    saveChoice();
  }, [selectedOption]);

  // setCurrentQuestionIndex()
  useEffect(() => {
    setCurrentQuestionIndex(candidate.questions?.[getStoredSubject().integerCode]?.currentQuestionIndex || 0);
    // console.log(props.candidate);
  }, [props.candidate.currentSubject, candidate.questions]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const sendAnyResponse = () => {
    // Send any local responses to server
    const responses = JSON.parse(localStorage.getItem("request"));
    if (responses && Object.keys(responses)?.length > 0) {
      // call SaveChoice actions
      const timeSpent = Number(localStorage.getItem("timeSpent"));
      props.saveChoice(props.candidate.id, { responses, timeSpent });
      // localStorage.removeItem('currentSubject');
      localStorage.removeItem("shouldCount");
    } else {
      socket.emit("timeSpent", {
        candidate: props.candidate.id,
        timeSpent: Number(localStorage.getItem("timeSpent")),
      });
      // localStorage.removeItem('currentSubject');
      // localStorage.removeItem('shouldCount');
    }
    // localStorage.clear();
  };

  const setOptionOnKeyboardPress = (value) => {
    let keyPressed = "";
    switch (value) {
      case "a":
      case "A":
        keyPressed = "A";
        break;
      case "b":
      case "B":
        keyPressed = "B";
        break;
      case "c":
      case "C":
        keyPressed = "C";
        break;
      case "d":
      case "D":
        keyPressed = "D";
        break;

      case "n":
      case "N":
      case "ArrowRight":
        keyPressed = "N";
        break;
      case "p":
      case "P":
      case "ArrowLeft":
        keyPressed = "P";
        break;
      case "s":
      case "S":
        keyPressed = "S";
        break;
      case "ArrowUp":
        keyPressed = "ArrowUp";
        break;
      case "ArrowDown":
        keyPressed = "ArrowDown";
        break;
      default:
        break;
    }

    if (keyPressed === "N") {
      nextButton.current.click();
    }

    if (keyPressed === "P") {
      prevButton.current.click();
    }

    if (keyPressed === "S") {
      // setIsEnd(true)
      endExamButton.current.click();
    }

    // if (keyPressed === "ArrowDown") {
    //     const options = ["A", "B", "C", "D"];

    //     if (select === 4) {
    //         select = 0;
    //     } else {
    //         select += 1;
    //     }

    //     const selected = options[select];
    //     keyPressed = selected;
    // }

    // if (keyPressed === "ArrowUp") {
    //     const options = ["A", "B", "C", "D"];

    //     if (select === 0) {
    //         select = 4;
    //     } else {
    //         select -= 1;
    //     }

    //     const selected = options[select];
    //     keyPressed = selected;
    // }
    setSelectedOption(keyPressed);
  };

  const handleKeyDown = (e) => {
    setOptionOnKeyboardPress(e.key);
    e.preventDefault();
  };

  if (!props.candidate) return "Loading...";

  const questionSet = props.candidate?.questions?.[props.candidate.currentSubject?.integerCode];
  const questionGroups = questionSet?.questions?.[0]?.groups || [];
  if (questionGroups.length === 0) {
    return (
      <div className="container-fluid mt-5">
        <div className="alert alert-danger shadow-sm">
          Questions are not available for {props.candidate?.currentSubject?.name || "this subject"}. Please contact Admin.
        </div>
      </div>
    );
  }

  var currentQuestion;

  if (currentQuestionIndex) {
    currentQuestion = questionGroups[currentQuestionIndex];
  } else {
    currentQuestion = questionGroups[0];
  }

  let btnColor;
  const renderQuestionsNav = () => {
    return questionGroups.map((question, i) => {
      if (question.choice) {
        btnColor = "btn-success";
      }
      if (currentQuestionIndex === i) {
        btnColor = "btn-primary";
      }
      if (!question.choice && currentQuestionIndex !== i) {
        btnColor = "btn-danger";
      }
      return (
        <button index={i} onClick={onSubmitForm} key={i} className={`${btnColor} btn btn-sm text-white mr-1 mb-1`}>
          {i + 1}
        </button>
      );
    });
  };

  const renderPassage = (question) => {
    const data = questionSet?.questions?.find((section) => section.questionId === question.questionId);
    return <div dangerouslySetInnerHTML={{ __html: `${data?.question || ""}` }} />;
  };

  const getTotal = () => {
    let total = 0;
    for (const subject of props.candidate.subjects) {
      total += props.candidate?.questions?.[subject.integerCode]?.questions?.[0]?.groups?.length || 0;
    }
    return total;
  };

  const onValueChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const saveChoice = () => {
    if (localStorage.getItem("shouldCount") === "false") {
      return;
    }
    const keyboardOptions = ["A", "B", "C", "D", "E"];
    // check if selectedOption is in array keyboardOptions
    const isValid = keyboardOptions.includes(selectedOption);

    if (!isValid) {
      return;
    }

    // Persist

    // Send to Server
    // get the Response object from localStorage and parse it
    const responses = JSON.parse(localStorage.getItem("request"));
    // add new response to object
    responses[currentQuestion.id] = {
      choice: selectedOption,
      candidate: props.candidate.id,
      subject: props.candidate.currentSubject.integerCode,
      // subject: JSON.parse(localStorage.getItem('currentSubject')).integerCode,
      currentQuestionIndex,
      currentQuestionCode: currentQuestion.id,
    };
    // save stringify object to localStorage
    localStorage.setItem("request", JSON.stringify(responses));

    // UPDATE UI
    const candidateQuestions = { ...props.candidate.questions };
    const copySubject = candidateQuestions[getStoredSubject().integerCode];
    if (!copySubject?.questions?.[0]?.groups?.[currentQuestionIndex]) return;
    if (!copySubject.questions[0].groups[currentQuestionIndex].choice) {
      copySubject.answeredCount ? (copySubject.answeredCount += 1) : (copySubject.answeredCount = 1);
      // candidate.totalAttempted++
      setCandidate({ ...candidate, totalAttempted: (candidate.totalAttempted += 1) });
    }
    localStorage.setItem("totalAttempted", candidate.totalAttempted);
    copySubject.questions[0].groups[currentQuestionIndex].choice = selectedOption;
    copySubject.currentQuestionIndex = currentQuestionIndex;
    setQuestions(copySubject.questions[0].groups);
    setCandidate({ ...candidate, questions: candidateQuestions });
    // setSelectedOption('');
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    // if (localStorage.getItem('shouldCount') === 'false') return;
    let nextQuestionIndex;
    let clickedBtn = e.target.getAttribute("index");
    // props.handleSubmit(onSubmitForm2())
    if (clickedBtn === "next") {
      nextQuestionIndex = Number(currentQuestionIndex) + 1;
    } else if (clickedBtn === "prev") {
      nextQuestionIndex = Number(currentQuestionIndex) - 1;
    } else {
      nextQuestionIndex = Number(clickedBtn);
    }

    //@TODO Update answered question in local state
    setCurrentQuestionIndex(nextQuestionIndex);
    setSelectedOption("");
  };

  const cancelEndModal = () => {
    setIsEnd(false);
  };
  const closeEarlySubmitModal = () => {
    setIsEarlySubmit(false);
  };

  const endExamHandler = (e) => {
    // e.preventDefault();
    if (localStorage.getItem("shouldCount") === "false") return;
    if (Number(localStorage.getItem("timeSpent")) < 300) {
      setIsEarlySubmit(true);
      return;
    }

    // Send any local responses to server
    // sendAnyResponse(); Done inside modal

    setIsEnd(true);
  };

  return (
    <React.Fragment>
      <EarlySubmissionModal isOpen={isEarlySubmit} toggle={closeEarlySubmitModal} />
      <PreSubmitModal isOpen={openPresubmit} />
      <NetworkConnectionModal isOpen={isOpenNModal} />
      <SubmitModal isOpen={isEnd} toggle={cancelEndModal} candidate={candidate} sendAnyResponse={sendAnyResponse} endMyExam={props.endMyExam} />
      <Topbar />
      {/* <!-- Page Heading --> */}
      <div className="align-items-center justify-content-between mb-3">
        {/* <h1 className="h5 mb-0 text-gray-800">{candidate.examCode} / Session {candidate.session}</h1> */}
        {/* <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i className="fas fa-download fa-sm text-white-50"></i> Generate Report</a> */}
      </div>

      <div className="row">
        {/* <!--  Instructions --> */}
        <div className="col-xl-10 col-md-10 mb-3">
          <div className="card border-left-success shadow h-100 py-1">
            <div className="card-body">
              <div className="d-sm-flex align-items-center justify-content-between">
                <h6 className="card-title text-success font-weight-bold">{props.candidate.currentSubject.name}</h6>
                <button onClick={endExamHandler} className="btn btn-sm btn-danger shadow-sm" ref={endExamButton}>
                  End Exam
                </button>
              </div>
              <h6 className="card-title font-weight-bold">Question {currentQuestionIndex + 1}</h6>
              <hr className="sidebar-divider" />
              {/* onSubmit={props.handleSubmit( onSubmitForm )} */}
              <form>
                <div className="row no-gutters align-items-center">
                  <div className="row mr-2 mb-4">
                    {questionSet?.questions?.length > 1 && renderPassage(currentQuestion)}
                    <div dangerouslySetInnerHTML={{ __html: `${currentQuestion?.question || ""} ` }} />
                    {(() => {
                      if (!currentQuestion?.optionses || currentQuestion?.optionses.length === 0) {
                        return null;
                      }

                      // Check first option immediately and skip everything if it matches
                      const firstOption = currentQuestion.optionses[0]?.option?.toLowerCase();
                      if (firstOption?.includes("theory-based-morgeng")) {
                        return null;
                      }

                      return (
                        <div style={{ width: "100%" }}>
                          {currentQuestion.optionses.map((opt, index) => {
                            const optionLetter = String.fromCharCode(65 + index); // A, B, C, D, E
                            return (
                              <div className="form-check" key={index}>
                                <label htmlFor={optionLetter} className="form-check-label mr-5">
                                  ({optionLetter})
                                </label>
                                <label className="form-check-label">
                                  <input
                                    type="radio"
                                    onChange={onValueChange}
                                    checked={currentQuestion?.choice === optionLetter}
                                    className="form-check-input"
                                    name="choice"
                                    id={optionLetter}
                                    value={optionLetter}
                                  />{" "}
                                  <span dangerouslySetInnerHTML={{ __html: `${opt?.option || ""} ` }} />
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                  <div className="row col-12">
                    <div className="col-xl-2 col-md-2 mb-3">
                      {currentQuestionIndex > 0 ? (
                        <button onClick={onSubmitForm} index="prev" className="btn btn-sm btn-success" ref={prevButton}>
                          Previous
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-xl-8 col-md-8">{renderQuestionsNav()}</div>
                    <div className="col-xl-2 col-md-2">
                      {currentQuestionIndex >= questionGroups.length - 1 ? (
                        ""
                      ) : (
                        <button onClick={onSubmitForm} index="next" className="btn btn-sm btn-success text-center" ref={nextButton}>
                          &nbsp;&nbsp;&nbsp; Next &nbsp;&nbsp;&nbsp;
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* <!-- Student Details --> */}
        <div className="col-xl-2 col-md-2 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <img
              style={{ width: "66%" }}
              className="rounded-circle card-img-top"
              alt={candidate.registrationNumber}
              src={candidate.photo || "/img/default.png"}
              onError={(e) => {
                e.target.src = "/img/default.png";
              }}
            />
            <div className="card-body">
              <h6 className="card-title">{candidate.name}</h6>
              <h6>{candidate.registrationNumber}</h6>
              <p>
                <span className="font-weight-bold">Exam Duration:</span> {Math.floor(props.candidate.durationInMinutes / 60)}hours {props.candidate.durationInMinutes % 60}mins
              </p>
              <p>
                <span className="font-weight-bold">Seat No:</span>
                {candidate.seatNo}
              </p>
              <p className="font-weight-bold">
                ATTEMPTED {props.subject?.answeredCount || 0} OF {questionGroups.length}
              </p>
              <p className="font-weight-bold">{props.candidate?.currentSubject.name}</p>
              <p className="font-weight-bold">TOTAL QUESTIONS ATTEMPTED:</p>
              <p className="font-weight-bold">
                {candidate.totalAttempted} OF {getTotal()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  // console.log(state.auth.user?.data?.questions[JSON.parse(localStorage.getItem('currentSubject')).integerCode]);
  return {
    candidate: state.auth.user.data,
    response: state.form.questionForm,
    subject: state.auth?.user?.data?.questions?.[getStoredSubject().integerCode] || {},
    //  || state.auth.user.data.questions["1"],
    currentSubject: state.currentSubject,
  };
};

export default connect(mapStateToProps, {
  saveChoice,
  fetchUser,
  updateMe,
  endMyExam,
  signout,
})(QuestionPage);
